"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["bsPrefix", "show", "closeLabel", "closeVariant", "className", "children", "variant", "onClose", "dismissible", "transition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import * as React from 'react';
import { useUncontrolled } from 'uncontrollable';
import useEventCallback from '@restart/hooks/useEventCallback';
import { useBootstrapPrefix } from './ThemeProvider';
import AlertHeading from './AlertHeading';
import AlertLink from './AlertLink';
import Fade from './Fade';
import CloseButton from './CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Alert = /*#__PURE__*/React.forwardRef(function (uncontrolledProps, ref) {
  var _useUncontrolled = useUncontrolled(uncontrolledProps, {
      show: 'onClose'
    }),
    bsPrefix = _useUncontrolled.bsPrefix,
    _useUncontrolled$show = _useUncontrolled.show,
    show = _useUncontrolled$show === void 0 ? true : _useUncontrolled$show,
    _useUncontrolled$clos = _useUncontrolled.closeLabel,
    closeLabel = _useUncontrolled$clos === void 0 ? 'Close alert' : _useUncontrolled$clos,
    closeVariant = _useUncontrolled.closeVariant,
    className = _useUncontrolled.className,
    children = _useUncontrolled.children,
    _useUncontrolled$vari = _useUncontrolled.variant,
    variant = _useUncontrolled$vari === void 0 ? 'primary' : _useUncontrolled$vari,
    onClose = _useUncontrolled.onClose,
    dismissible = _useUncontrolled.dismissible,
    _useUncontrolled$tran = _useUncontrolled.transition,
    transition = _useUncontrolled$tran === void 0 ? Fade : _useUncontrolled$tran,
    props = _objectWithoutProperties(_useUncontrolled, _excluded);
  var prefix = useBootstrapPrefix(bsPrefix, 'alert');
  var handleClose = useEventCallback(function (e) {
    if (onClose) {
      onClose(false, e);
    }
  });
  var Transition = transition === true ? Fade : transition;
  var alert = /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    role: "alert"
  }, !Transition ? props : undefined), {}, {
    ref: ref,
    className: classNames(className, prefix, variant && "".concat(prefix, "-").concat(variant), dismissible && "".concat(prefix, "-dismissible")),
    children: [dismissible && /*#__PURE__*/_jsx(CloseButton, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  }));
  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/_jsx(Transition, _objectSpread(_objectSpread({
    unmountOnExit: true
  }, props), {}, {
    ref: undefined,
    "in": show,
    children: alert
  }));
});
Alert.displayName = 'Alert';
export default Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
});